import React, { useState, useEffect } from "react";
import { getFirestore } from "../../config/firebase";

const FinancingCard = ({
  banco,
  logo,
  color,
  etiquetas,
  titulo,
  tasa,
  tasaDestacada,
  detalle,
  detalleDestacado,
  link,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [whatsappUrl, setWhatsappUrl] = useState(null);

  // Cargar la URL de WhatsApp desde sessionStorage o Firestore
  useEffect(() => {
    const cargarDatosInformacion = async () => {
      // Intentar recuperar los datos de sessionStorage
      const datosLocales = sessionStorage.getItem("hyundai-informacion");
      if (datosLocales) {
        // Si los datos existen, parsearlos y establecer la URL de WhatsApp
        const datosCompletos = JSON.parse(datosLocales);
        setWhatsappUrl(datosCompletos[1].url);
      } else {
        // Si no hay datos en sessionStorage, hacer la llamada a Firestore
        const db = getFirestore();
        const vehicles = db.collection("hyundai-informacion");
        try {
          const querySnapshot = await vehicles.get();
          const datosCompletos = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          // Actualizar la URL de WhatsApp con los datos de Firestore
          setWhatsappUrl(datosCompletos[1].url);
          // Guardar los datos en sessionStorage
          sessionStorage.setItem("hyundai-informacion", JSON.stringify(datosCompletos));
        } catch (error) {
          console.error("Error al obtener datos de Firestore: ", error);
        }
      }
    };

    // Ejecutar la función de carga de datos
    cargarDatosInformacion();
  }, []);

  // Función para abrir WhatsApp
  const handleWhatsAppClick = () => {
    if (whatsappUrl) {
      window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    } else {
      console.error("URL de WhatsApp no disponible");
    }
  };

  // Simula el submit del modal (puedes personalizarlo)
  const handleModalSubmit = async (values) => {
    setLoading(true);
    // Aquí podrías enviar los datos a tu backend o analytics
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
      // Redirigir a WhatsApp si querés
      // window.location.href = 'https://api.whatsapp.com/send?...';
    }, 1000);
  };

  return (
    <div
      style={{
        boxShadow: "0 4px 8px rgba(0,0,0,0.12)",
        borderRadius: 16,
        padding: 24,
        background: "#fff",
        border: "1px solid #eee",

        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
        {logo && <img src={logo} alt={banco} style={{ height: 36, marginRight: 8 }} />}
      </div>
      <div style={{ marginBottom: 12 }}>
        {etiquetas &&
          etiquetas.map((et, i) => (
            <span
              key={i}
              style={{
                background: "#888",
                color: "#fff",
                borderRadius: 8,
                padding: "4px 12px",
                marginRight: 8,
                fontWeight: 400,
                paddingTop: 10,
                paddingBottom: 6,
                fontSize: 18,
              }}
            >
              {et}
            </span>
          ))}
        {tasaDestacada && (
          <span
            style={{
              background: "#00f",
              color: "#fff",
              borderRadius: 8,
              padding: "4px 12px",
              fontWeight: 400,
              paddingTop: 10,
              paddingBottom: 6,
              fontSize: 18,
            }}
          >
            {tasaDestacada}
          </span>
        )}
      </div>
      <div style={{ marginBottom: 12, marginTop: 12 }}>
        <p style={{ fontSize: 20 }}>
          {titulo}{" "}
          {tasa && (
            <span style={{ fontWeight: 700, fontSize: 22 }}>
              {tasa} {detalle && <span style={{ fontSize: 18 }}>{detalle}</span>}
            </span>
          )}
        </p>

        {detalleDestacado && <div style={{ fontWeight: 400, fontSize: 20, marginTop: 8 }}>{detalleDestacado}</div>}
      </div>
      <div>
        <button
          onClick={handleWhatsAppClick}
          style={{
            color: "#00f",
            fontWeight: 500,
            fontSize: 18,
            textDecoration: "none",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          Consultá ahora <span style={{ fontSize: 22, marginLeft: 4 }}>→</span>
        </button>
      </div>
    </div>
  );
};

export default FinancingCard;
